"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var SelloutReleaseType_1 = require("../../release/model/sellout/SelloutReleaseType");

var SelloutSettings_1 = require("../model/SelloutSettings");

var SelloutDescriptionConverter_1 = require("./SelloutDescriptionConverter");

var SelloutSettingsConverter_1 = require("./SelloutSettingsConverter");

var SelloutSubSettingsConverter_1 = require("./SelloutSubSettingsConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSettingsConverterImpl =
/*#__PURE__*/
function (_SelloutSettingsConve) {
  _inherits(SelloutSettingsConverterImpl, _SelloutSettingsConve);

  function SelloutSettingsConverterImpl(selloutDescriptionConverter, selloutSubSettingsConverter) {
    var _this;

    _classCallCheck(this, SelloutSettingsConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutSettingsConverterImpl).call(this));
    _this.selloutDescriptionConverter = selloutDescriptionConverter;
    _this.selloutSubSettingsConverter = selloutSubSettingsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutSettingsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutSettings_1.SelloutSettings(SelloutSettings_1.SelloutSettings.schema.id.valueOf(conversions.documentToClassId(source)), SelloutSettings_1.SelloutSettings.schema.selloutType.valueOf(conversions.asEnum(source.selloutType, SelloutReleaseType_1.SelloutReleaseType)), SelloutSettings_1.SelloutSettings.schema.priceListTypeId.valueOf(conversions.toClassReferenceId(source.priceListTypeId)), SelloutSettings_1.SelloutSettings.schema.description.valueOf(this.selloutDescriptionConverter.toObject(source.description, conversions)), SelloutSettings_1.SelloutSettings.schema.settings.valueOf(source.settings && this.selloutSubSettingsConverter.toObject(source.settings, conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        selloutType: source.selloutType,
        priceListTypeId: conversions.toDocumentReferenceId(source.priceListTypeId),
        description: this.selloutDescriptionConverter.toDocument(source.description, conversions),
        settings: source.settings && this.selloutSubSettingsConverter.toDocument(source.settings, conversions)
      });
      return result;
    }
  }]);

  return SelloutSettingsConverterImpl;
}(SelloutSettingsConverter_1.SelloutSettingsConverter);

SelloutSettingsConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutDescriptionConverter_1.SelloutDescriptionConverter, SelloutSubSettingsConverter_1.SelloutSubSettingsConverter])], SelloutSettingsConverterImpl);
exports.SelloutSettingsConverterImpl = SelloutSettingsConverterImpl;